const baseUrl = process.env.NEXT_PUBLIC_BASE_URL;

// deliberately has no fallback, unlike every other var here - hub and hubpro resolve to different
// origins, so a default would silently hand every page on the other app a cross-domain canonical,
// og:url and sitemap <loc>. checking here rather than at the ~80 call sites because most of those
// only concatenate it, and `undefined + '/path'` is legal typescript that yields 'undefined/path'
if (!baseUrl) {
  throw new Error('NEXT_PUBLIC_BASE_URL is not set');
}

export const BASE_URL = baseUrl;
export const ENTRIES_PER_PAGE = parseInt(process.env.NEXT_PUBLIC_ENTRIES_PER_PAGE || '25');
export const ENTRIES_PER_SITEMAP = parseInt(process.env.NEXT_PUBLIC_ENTRIES_PER_SITEMAP || '100');

export const DEFAULT_BACKGROUND_COLOR = '282818';

export const PROFILES_BANNER_COLOR = '0e7490';

export const PROFILES_BANNER_TEXT_COLOR = 'ffffff';

export const PROFILES_TEXT_COLOR = '000000';

export const IFRAME_BACKGROUND_COLOR = 'FFFFFF';

// stands in for an account that has no name, and for a HUB hero whose name is hidden, since the
// HUB hero always renders and needs something to show
export const ANONYMOUS_ACCOUNT_NAME = 'Private Collection';

// the theme tester frames the HUB, and is the only origin allowed to do so. Accepts a whitespace
// or comma separated list so several testers (local, staging, production) can be allowed at once.
// Comma has meaning inside a CSP header value, so it is a delimiter here and never reaches one
export const THEME_TESTER_ORIGINS = (process.env.NEXT_PUBLIC_THEME_TESTER_ORIGINS ?? '')
  .split(/[\s,]+/)
  .filter(Boolean);

// hubpro routes the proxy rewrites to when a host has no account, or when looking it up failed. Each
// must match its folder in hubpro/src/app. Capitalized because account slugs are always lowercase, so
// no [accountId] can collide with them
export const HOST_NOT_FOUND_SEGMENT = 'Host-Not-Found';
export const HOST_LOOKUP_ERROR_SEGMENT = 'Host-Lookup-Error';
// neither has an account, so no header to clear and nothing tracked
export const HOST_ERROR_SEGMENTS = [HOST_NOT_FOUND_SEGMENT, HOST_LOOKUP_ERROR_SEGMENT];
